import { ActionType } from "../constants/colorpicker";
import { color } from "@material-ui/system";

export const openColorPickerAction = () => dispatch => {
  return dispatch({
    type: ActionType.OPEN_COLOR_PICKER
  });
};

export const closeColorPickerAction = (data) => dispatch => {
  return dispatch({
    type: ActionType.CLOSE_COLOR_PICKER,
    payload: data
  });
};

export const setColorAction = (color) => dispatch => {
  return dispatch({
    type: ActionType.SET_COLOR,
    payload: color
  });
};

